var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapMarker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 3.33398C13.55 3.33398 8.33331 8.55065 8.33331 15.0007C8.33331 23.7507 20 36.6673 20 36.6673C20 36.6673 31.6666 23.7507 31.6666 15.0007C31.6666 8.55065 26.45 3.33398 20 3.33398ZM20 19.1673C18.8949 19.1673 17.8351 18.7283 17.0537 17.9469C16.2723 17.1655 15.8333 16.1057 15.8333 15.0007C15.8333 13.8956 16.2723 12.8358 17.0537 12.0544C17.8351 11.273 18.8949 10.834 20 10.834C21.105 10.834 22.1649 11.273 22.9463 12.0544C23.7277 12.8358 24.1666 13.8956 24.1666 15.0007C24.1666 16.1057 23.7277 17.1655 22.9463 17.9469C22.1649 18.7283 21.105 19.1673 20 19.1673Z",
    fill: "#F5EB8D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapMarker);
export default __webpack_public_path__ + "static/media/map-marker.c0dcecd5e43a6e91ffd51f4b99be07b5.svg";
export { ForwardRef as ReactComponent };